export const API_S3 = 'https://kxqcnthcrvgpokjxoldz.supabase.co/storage/v1/object/public/cabral-api';